import { render, staticRenderFns } from "./w-switch.vue?vue&type=template&id=64920783&lang=pug&"
import script from "./w-switch.vue?vue&type=script&lang=js&"
export * from "./w-switch.vue?vue&type=script&lang=js&"
import style0 from "./w-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64920783')) {
      api.createRecord('64920783', component.options)
    } else {
      api.reload('64920783', component.options)
    }
    module.hot.accept("./w-switch.vue?vue&type=template&id=64920783&lang=pug&", function () {
      api.rerender('64920783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-switch.vue"
export default component.exports